import React, { useRef } from 'react';
import s from './Sidebar.module.css';
import { Icons } from './Icons';
import { store } from '../../utils/store';

const NAV = [
  { sec: 'Principal', items: [
    { id: 'dashboard',    ic: <Icons.Dashboard/>,    lbl: 'Dashboard' },
    { id: 'agendamentos', ic: <Icons.Calendar/>,     lbl: 'Agendamentos' },
    { id: 'finalizados',  ic: <Icons.CheckCircle/>,  lbl: 'Finalizados' },
  ]},
  { sec: 'Gestão', items: [
    { id: 'clientes',      ic: <Icons.Users/>,    lbl: 'Clientes' },
    { id: 'servicos',      ic: <Icons.Scissors/>, lbl: 'Serviços' },
    { id: 'profissionais', ic: <Icons.User/>,     lbl: 'Profissionais' },
    { id: 'horarios',      ic: <Icons.Clock/>,    lbl: 'Horários' },
    { id: 'link',          ic: <Icons.Link/>,     lbl: 'Link de Agendamento' },
  ]},
  { sec: 'Conta', items: [
    { id: 'perfil',        ic: <Icons.Settings/>, lbl: 'Perfil' },
  ]},
];

// Converte qualquer imagem para WebP usando Canvas
function converterParaWebP(file, maxSize = 400) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      // Redimensiona mantendo proporção, máx 400x400
      let w = img.width, h = img.height;
      if (w > maxSize || h > maxSize) {
        if (w > h) { h = Math.round(h * maxSize / w); w = maxSize; }
        else       { w = Math.round(w * maxSize / h); h = maxSize; }
      }
      const canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob(blob => {
        if (!blob) { reject(new Error('Falha ao converter imagem')); return; }
        resolve(new File([blob], 'logo.webp', { type: 'image/webp' }));
      }, 'image/webp', 0.85);
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Imagem inválida')); };
    img.src = url;
  });
}

export function Sidebar({ user, page, onNav, onLogout, open, onClose, logo, onLogoChange, acesso }) {
  const ref = useRef();
  const [uploading, setUploading] = React.useState(false);

  const handleFile = async (e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.size > 5 * 1024 * 1024) { alert('Máximo 5MB'); return; }
    e.target.value = '';
    setUploading(true);
    try {
      // Converte para WebP antes de fazer upload
      const webpFile = await converterParaWebP(f);
      await store.uploadLogo(webpFile);
    } catch (err) {
      alert('Erro ao salvar logo: ' + err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      {open && <div className={s.ov} onClick={onClose} />}
      <nav className={`${s.sb} ${open ? s.open : ''}`}>
        <div className={s.logo}>
          <div
            className={s.lw}
            onClick={() => !uploading && ref.current?.click()}
            title="Clique para trocar logo"
            style={{ opacity: uploading ? 0.6 : 1, cursor: uploading ? 'wait' : 'pointer' }}
          >
            {logo
              ? <img src={logo} alt="" className={s.li} />
              : <div className={s.lb2}>
                  <span className={s.li2}>{(user?.empresa || 'E')[0].toUpperCase()}</span>
                  <div className={s.lh}>
                    {uploading ? <span style={{fontSize:10}}>...</span> : <><Icons.Camera/><span>foto</span></>}
                  </div>
                </div>
            }
            {logo && !uploading && (
              <button
                className={s.lr}
                onClick={e => { e.stopPropagation(); onLogoChange(null); }}
              >✕</button>
            )}
          </div>
          <input ref={ref} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
          <div>
            <div className={s.lt}>{user?.empresa || 'AgendaPro'}</div>
            <div className={s.ls}>
              {uploading ? 'Salvando logo...' : 'Gestão Inteligente'}
            </div>
          </div>
        </div>

        <div className={s.nav}>
          {NAV.map(({ sec, items }) => (
            <div className={s.grp} key={sec}>
              <span className={s.gl}>{sec}</span>
              {items.map(item => (
                <button
                  key={item.id}
                  className={`${s.ni} ${page === item.id ? s.ac : ''}`}
                  onClick={() => { onNav(item.id); onClose(); }}
                >
                  <span className={s.ic}>{item.ic}</span>{item.lbl}
                </button>
              ))}
            </div>
          ))}
        </div>

        <div className={s.bot}>
          {acesso?.status === 'trial' && (
            <button
              className={s.ni}
              onClick={() => { onNav('assinatura'); onClose(); }}
              style={{ color: '#f59e0b', marginBottom: 4 }}
            >
              <span className={s.ic}>⏳</span>
              {acesso.dias_trial_restantes} dias grátis
            </button>
          )}
          <button className={`${s.ni} ${s.out}`} onClick={onLogout}>
            <span className={s.ic}><Icons.Logout /></span>Sair
          </button>
        </div>
      </nav>
    </>
  );
}
